import { updateUserRole } from '../actions/user'

export const jsonResponseHandler = (dispatch, noSystemAlert) => (res) => {

    if(!res.ok) {
        if(res.status === 401){
            if (dispatch) {
                res.json().then(json => {
                    if(json.currentRole){dispatch(updateUserRole(json.currentRole))};
                    if(json.message) alert(json.message);
                });
            }
            throw res;
        }else if(res.status === 403){
        	  if (dispatch) {
                res.json().then(json => {
                    if(json.currentRole){dispatch(updateUserRole(json.currentRole))};
				        });
			      }
            throw res;
        }else{
            if (noSystemAlert) {

            }else{
              res.json().then(json => { if(json.message) alert(json.message)});
            }

            throw res;
        }
    }else{
        return res;
    }
};

export const revenueResponseHandler = (dispatch) => (res) => {
    // TODO: 수익센터 response exception 처리.
    return res;
};
